import api from "./api/api";
import { UsuarioForm } from "../types/usuarios";

const UsersNewService = {
    getUsuarios: (search: string, page: number = 1, perPage: number = 10) => {
        return api.get("/new/users", {
            params: { s: search, page, per_page: perPage }
        });
    },

    getUsuario: (id: number) => {
        return api.get(`/new/users/${id}`);
    },

    vincularUsuario: (data: UsuarioForm, edicao: boolean) => {
        const body: any = { ...data };
        if (edicao) {
            body.edicao = true;
        }
        return api.post("/new/users/vincular", body);
    },

    getNiveisAcesso: () => {
        return api.get("/new/users/opcoes-nivel-de-acesso");
    },

    deleteUsuario: (id: number) => {
        return api.delete(`/new/users/${id}`);
    },
};

export default UsersNewService;
